import { Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PortalSourcingEventDetailDto, useGetPortalAwardLetterQuery } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { usePortalProcurementTerms } from "../../../../common/terminology/useProcurementTerms";
import { AwardLetterPreview } from "../../../v2/sourcing-event/award/AwardLetterPreview";

export const EventAwardNotificationSection = ({ event }: { event: PortalSourcingEventDetailDto }) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const terms = usePortalProcurementTerms(event);
  const { data } = useGetPortalAwardLetterQuery({ eventId: event.id });
  const letter = data?.letter;
  if (!letter) return null;

  const criteria = (event.awardCriteria?.criteria ?? [])
    .filter((c): c is typeof c & { id: string } => !!c.id)
    .map((c) => ({ id: c.id, name: c.name?.trim() || t("Criterion") || "" }));

  const standstillExpiresAt = data?.standstillExpiresAt ?? undefined;

  return (
    <Stack spacing="3">
      <Text fontSize="lg" fontWeight="semibold" color="smText">
        {t("Your award notification")}
      </Text>
      <AwardLetterPreview
        type={letter.type}
        supplierName={letter.supplierName || ""}
        winnerName={t("the selected supplier")}
        eventTitle={event.title}
        senderName={event.buyerName}
        scoreHeading={terms.scorePerAwardCriterion}
        criterionJustifications={letter.content.criterionJustifications ?? {}}
        freeText={letter.content.freeText}
        criteria={criteria}
        sentAt={letter.sentAt}
        regulation={data?.regulation}
      />
      {standstillExpiresAt && (
        <Box bg="smBackgroundSecondary" rounded="md" border="1px solid" borderColor="smBorder" p="4">
          <Text fontSize="sm" color="smText">
            {t("The award decision is not final until {{date}}, during which it may be challenged.", {
              date: displayDate(standstillExpiresAt),
            })}
          </Text>
        </Box>
      )}
    </Stack>
  );
};
